export const SHOW_ORG_LOGO_CHOICES = ['default', 'show', 'hide'] as const;
export type ShowOrgLogoChoice = (typeof SHOW_ORG_LOGO_CHOICES)[number];

/** Form choice -> wire value. null = inherit org default. */
export const SHOW_ORG_LOGO_TO_API: Record<ShowOrgLogoChoice, boolean | null> = {
  default: null,
  show: true,
  hide: false,
};

/** Wire value -> form choice. */
export function showOrgLogoFromApi(value: boolean | null): ShowOrgLogoChoice {
  if (value === null) return 'default';
  return value ? 'show' : 'hide';
}

/** Human labels — used by the select options and the detail badge. */
export const SHOW_ORG_LOGO_LABELS: Record<ShowOrgLogoChoice, string> = {
  default: 'Use org default',
  show: 'Always show',
  hide: 'Never show',
};
